/*
* @todo - Move modeToggle to this store
* @todo - A strategy to handle with scrolling
*/

import {defineStore} from 'pinia';
import {ref} from 'vue';

export const useUiStore = defineStore('ui', () => {
  const showVerificationModal = ref(false);
  const showCookieAccessModal = ref(false);
    const state = ref({
      scrollToTop: false,
    })
    
    const toggleScrollToTop = () => {
      state.value.scrollToTop = !state.value.scrollToTop
    }

    return {
        state,
        toggleScrollToTop,
        showVerificationModal,
        showCookieAccessModal,
    };
});
